import { ModelBase } from './model';

class Card extends ModelBase {
  static namespace = 'card';
}
export default Card.register();
